<template>
<div class="RssReader">
    <div class="RssReader__title">{{ title }}</div>
    <div class="RssReader__content">
        <div v-html="content"></div>
    </div>
</div>
</template>
<script>
export default {
  name: 'RssReader',
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="sass">
.RssReader
  background: white
  +flex(flex-start, center, column)
  &__title
    +title
  &__content
    +size(100%, 100%)
    +text_bold
    line-height: 2
    margin: 10%
</style>
